<template>
  <form class="mt-4"
        @submit.prevent="updateEmailData">
    <div class="row justify-content-start mb-2">
      <div class="col-md-12 col-sm-12">
        <h4>{{ $t('ManageSystemView.emailSettings') }}</h4>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-md-12 col-sm-12 form-group mb-4">
        <label class="form-label"
               for="odkUrl">
          {{ $t('ManageSystemView.senderEmailAddress') }}
        </label>
        <input type="text"
               id="senderEmail"
               class="form-control rounded-pill"
               placeholder=""
               v-model="senderEmail"/>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col col-md-6 col-sm-12 form-group">
        <button type="submit"
                class="btn btn-success rounded-pill mb-4 w-100">
          <i class="bi bi-plus-circle"></i> {{ $t('save') }}
        </button>
      </div>
    </div>
  </form>
</template>
<script>
import {getAllSettings, putSettings} from "@/utils";

export default {
  data() {
    return {
      senderEmail: '',
    }
  },
  async mounted() {
    let response = await getAllSettings();
    if (response.status === 200) {
      this.senderEmail = response.data.sender_email_address;
    } else {
      this.message = response.response.data.message;
      this.messageType = "danger";
    }
  },
  methods: {
    async updateEmailData() {
      await putSettings({'sender_email_address': this.senderEmail});
    }
  }
}
</script>